import {
    Typography, Button, Icon, Box,
    CardActions, CardContent, CardMedia
} from '@mui/material'

import { useNavigate } from 'react-router-dom'
import { generateUrl } from '@services/routes'
import { ROUTE_LANDING_ZONES_ID_MODE } from '@features/routes'

import Tile from '@components/Tile'

import azureLogo from './media/azureLogo.png'
import awsLogo from './media/awsLogo.png'

export const LzCard = ({ id, azure, aws, needMigration, subscription }) => {
    let logo = azureLogo
    if (azure) logo = azureLogo
    if (aws) logo = awsLogo

    const navigate = useNavigate()

    const handleMigration = () => {

        if (needMigration && subscription && !aws) {

            const targetUrl = generateUrl(
                ROUTE_LANDING_ZONES_ID_MODE,
                { id: id, mode: 'firewall-migration' }
            )
            
            navigate(targetUrl)
        }
    }

    const handleSettings = () => {
        if (id) navigate(generateUrl(ROUTE_LANDING_ZONES_ID_MODE, { id: id, mode: 'groups' }))
    }

    return (
        <Tile sx={{ width: '240px', padding: 0 }}>
            <Box onClick={handleSettings} sx={{ cursor: 'pointer' }}>
                <CardMedia
                    sx={{ borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                    component={'img'}
                    alt={id}
                    height={'140'}
                    image={logo}
                />
                <CardContent>
                    <Typography variant="h4">{id}</Typography>
                </CardContent>
            </Box>
            {!aws && (
                <CardActions sx={{ paddingBottom: '16px' }}>
                    {needMigration && (
                        <Button variant={'secondary'} onClick={handleMigration} startIcon={<Icon>sync_alt</Icon>} sx={{ width: '100%' }}>
                            Firewall migration
                        </Button>
                    )}
                </CardActions>
            )}
        </Tile>
    )
}

export default LzCard